export interface Comic {
  id: string;
  title: string;
  category: string;
  tags: string[];
  status: '连载中' | '已完结';
  chapters: number;
  likes: string;
  views: string;
  score: string;
  author: string;
  intro: string;
  cover: string;
  featured?: boolean;
}

export const categories: string[] = ['全部', '热血', '科幻', '玄幻', '悬疑', '恋爱', '日常'];

export const comics: Comic[] = [
  {
    id: 'xinghai',
    title: '星海征途',
    category: '科幻',
    tags: ['机甲', '冒险', '太空'],
    status: '连载中',
    chapters: 328,
    likes: '48万',
    views: '3.2亿',
    score: '9.2',
    author: '岚川',
    intro: '人类在星际殖民时代迷失方向，少年舰长驾驶破损的星舰，在无垠星海中寻找回家的航路。',
    cover: 'https://readdy.ai/api/search-image?query=vibrant%20manga%20comic%20book%20cover%20art%20of%20a%20young%20captain%20standing%20on%20a%20spaceship%20deck%20facing%20a%20glowing%20nebula%2C%20mecha%20sci-fi%20illustration%2C%20bold%20dynamic%20composition%2C%20dramatic%20lighting%2C%20detailed%20inking%2C%20warm%20orange%20and%20deep%20blue%20color%20scheme%2C%20epic%20cinematic%20atmosphere&width=600&height=800&seq=comic-xinghai&orientation=portrait',
    featured: true,
  },
  {
    id: 'jianxiao',
    title: '剑啸山河',
    category: '玄幻',
    tags: ['武侠', '修仙', '国风'],
    status: '连载中',
    chapters: 512,
    likes: '62万',
    views: '4.8亿',
    score: '9.5',
    author: '墨守白',
    intro: '身负家仇的少年剑客踏入九洲乱世，一路斩妖破障，在血与火中参悟绝世剑意。',
    cover: 'https://readdy.ai/api/search-image?query=epic%20manga%20comic%20cover%20art%20of%20a%20swordsman%20in%20flowing%20hanfu%20holding%20a%20glowing%20sword%20against%20a%20misty%20mountain%20background%2C%20wuxia%20fantasy%20illustration%2C%20ink%20wash%20style%2C%20dramatic%20pose%2C%20warm%20amber%20and%20charcoal%20tones%2C%20detailed%20brushwork%2C%20cinematic%20lighting&width=600&height=800&seq=comic-jianxiao&orientation=portrait',
    featured: true,
  },
  {
    id: 'chengshi',
    title: '都市异能录',
    category: '悬疑',
    tags: ['都市', '异能', '推理'],
    status: '连载中',
    chapters: 201,
    likes: '35万',
    views: '2.1亿',
    score: '8.9',
    author: '夜枭',
    intro: '平凡上班族意外觉醒读心异能，却发现自己卷入一场横跨整座城市的超自然阴谋。',
    cover: 'https://readdy.ai/api/search-image?query=manga%20comic%20cover%20art%20of%20a%20mysterious%20city%20detective%20in%20a%20trench%20coat%20standing%20in%20a%20rainy%20neon%20city%20street%2C%20urban%20supernatural%20thriller%2C%20noir%20atmosphere%2C%20bold%20ink%20lines%2C%20moody%20teal%20and%20crimson%20lighting%2C%20dramatic%20composition&width=600&height=800&seq=comic-chengshi&orientation=portrait',
  },
  {
    id: 'qingchun',
    title: '青春如歌',
    category: '恋爱',
    tags: ['校园', '恋爱', '治愈'],
    status: '已完结',
    chapters: 156,
    likes: '71万',
    views: '5.6亿',
    score: '9.4',
    author: '南栀',
    intro: '转学来的女孩与沉默寡言的少年，在四季更迭的校园里写下一段温柔而明亮的青春恋曲。',
    cover: 'https://readdy.ai/api/search-image?query=soft%20pastel%20manga%20comic%20cover%20art%20of%20a%20high%20school%20couple%20under%20cherry%20blossom%20trees%20on%20a%20sunny%20campus%2C%20romance%20slice%20of%20life%20illustration%2C%20gentle%20lighting%2C%20warm%20cream%20and%20pink%20tones%2C%20delicate%20linework%2C%20wholesome%20atmosphere&width=600&height=800&seq=comic-qingchun&orientation=portrait',
    featured: true,
  },
  {
    id: 'yushou',
    title: '御兽纪元',
    category: '热血',
    tags: ['冒险', '御兽', '成长'],
    status: '连载中',
    chapters: 287,
    likes: '54万',
    views: '3.9亿',
    score: '9.1',
    author: '赤练',
    intro: '天赋异禀的少年契约了一只最低阶的幻兽，却一步步将它培育成撼动纪元的传说之王。',
    cover: 'https://readdy.ai/api/search-image?query=energetic%20manga%20comic%20cover%20of%20a%20young%20trainer%20with%20a%20mythical%20beast%20in%20a%20vast%20wilderness%2C%20monster%20taming%20adventure%2C%20bold%20dynamic%20illustration%2C%20vibrant%20orange%20and%20golden%20color%20palette%2C%20action%20pose%2C%20epic%20lighting&width=600&height=800&seq=comic-yushou&orientation=portrait',
  },
  {
    id: 'anzhen',
    title: '暗夜侦探',
    category: '悬疑',
    tags: ['推理', '都市', '罪案'],
    status: '连载中',
    chapters: 174,
    likes: '29万',
    views: '1.7亿',
    score: '8.8',
    author: '灰鸦',
    intro: '白天经营旧书店的老板，夜晚化身只接无头悬案的侦探，揭开城市灯光下的重重迷雾。',
    cover: 'https://readdy.ai/api/search-image?query=moody%20manga%20comic%20cover%20of%20a%20detective%20silhouette%20under%20a%20single%20street%20lamp%20in%20the%20night%2C%20noir%20mystery%20illustration%2C%20deep%20shadows%20and%20warm%20amber%20light%2C%20bold%20ink%20style%2C%20dramatic%20atmosphere%2C%20intriguing%20composition&width=600&height=800&seq=comic-anzhen&orientation=portrait',
  },
  {
    id: 'meishi',
    title: '美食无双',
    category: '日常',
    tags: ['美食', '治愈', '下饭'],
    status: '已完结',
    chapters: 120,
    likes: '66万',
    views: '5.1亿',
    score: '9.3',
    author: '酥麻',
    intro: '深夜小巷里的无名食堂，用一道道暖胃料理，治愈着每一位疲惫都市人的故事。',
    cover: 'https://readdy.ai/api/search-image?query=appetizing%20manga%20comic%20cover%20of%20a%20chef%20in%20a%20warm%20kitchen%20with%20steaming%20delicious%20dishes%2C%20culinary%20slice%20of%20life%20illustration%2C%20cozy%20warm%20lighting%2C%20vibrant%20food%20colors%2C%20bold%20lines%2C%20heartwarming%20atmosphere&width=600&height=800&seq=comic-meishi&orientation=portrait',
    featured: true,
  },
  {
    id: 'jijia',
    title: '机甲少年',
    category: '热血',
    tags: ['机甲', '校园', '战斗'],
    status: '连载中',
    chapters: 342,
    likes: '58万',
    views: '4.2亿',
    score: '9.0',
    author: '铁砧',
    intro: '天才机甲驾驶员少年，在精英学院里与同伴并肩作战，守护人类最后一片蔚蓝天空。',
    cover: 'https://readdy.ai/api/search-image?query=dynamic%20manga%20comic%20cover%20of%20a%20teen%20pilot%20inside%20a%20gigantic%20mech%20warrior%20at%20sunset%2C%20mecha%20action%20illustration%2C%20bold%20dramatic%20pose%2C%20orange%20sunset%20and%20steel%20tones%2C%20detailed%20mechanical%20design%2C%20epic%20energy&width=600&height=800&seq=comic-jijia&orientation=portrait',
  },
  {
    id: 'shijian',
    title: '时间旅人',
    category: '科幻',
    tags: ['穿越', '悬疑', '烧脑'],
    status: '连载中',
    chapters: 189,
    likes: '41万',
    views: '2.8亿',
    score: '9.3',
    author: '钟表匠',
    intro: '能自由穿梭时间线的旅人，试图阻止一场波及整个时代的浩劫，却不断撞见自己的倒影。',
    cover: 'https://readdy.ai/api/search-image?query=surreal%20manga%20comic%20cover%20of%20a%20time%20traveler%20before%20a%20giant%20clock%20face%20with%20melted%20clocks%20floating%20around%2C%20sci-fi%20mystery%20illustration%2C%20intricate%20detail%2C%20warm%20gold%20and%20deep%20indigo%20palette%2C%20dreamlike%20atmosphere&width=600&height=800&seq=comic-shijian&orientation=portrait',
  },
  {
    id: 'wangchao',
    title: '王朝再临',
    category: '玄幻',
    tags: ['历史', '权谋', '史诗'],
    status: '已完结',
    chapters: 438,
    likes: '39万',
    views: '2.6亿',
    score: '9.0',
    author: '秦川',
    intro: '亡国太子从血泊中重生，以一人之谋，搅动天下棋局，誓要再建一个锦绣王朝。',
    cover: 'https://readdy.ai/api/search-image?query=grand%20manga%20comic%20cover%20of%20a%20young%20emperor%20on%20a%20battleground%20with%20a%20crimson%20banner%2C%20historical%20fantasy%20illustration%2C%20ancient%20china%20style%2C%20dramatic%20war%20scene%2C%20gold%20and%20crimson%20tones%2C%20bold%20ink%20outlines%2C%20epic%20composition&width=600&height=800&seq=comic-wangchao&orientation=portrait',
  },
  {
    id: 'xingyu',
    title: '星域猎手',
    category: '科幻',
    tags: ['赏金', '冒险', '太空'],
    status: '连载中',
    chapters: 143,
    likes: '22万',
    views: '1.2亿',
    score: '8.7',
    author: '风骨',
    intro: '赏金猎人少女穿梭于各大星系，接下最危险的任务，只为寻回失散多年的家人。',
    cover: 'https://readdy.ai/api/search-image?query=vibrant%20manga%20comic%20cover%20of%20a%20female%20bounty%20hunter%20with%20a%20plasma%20gun%20in%20a%20colorful%20space%20bazaar%2C%20space%20adventure%20illustration%2C%20bold%20colors%2C%20warm%20orange%20highlights%20and%20cool%20shadows%2C%20dynamic%20action%20pose%2C%20energetic%20atmosphere&width=600&height=800&seq=comic-xingyu&orientation=portrait',
  },
  {
    id: 'lingneng',
    title: '灵能觉醒',
    category: '热血',
    tags: ['异能', '学院', '战斗'],
    status: '连载中',
    chapters: 265,
    likes: '33万',
    views: '2.3亿',
    score: '8.9',
    author: '白昼',
    intro: '被封印的灵能少年在觉醒仪式上失控，从此踏上掌控自我力量、对抗暗黑组织的征途。',
    cover: 'https://readdy.ai/api/search-image?query=powerful%20manga%20comic%20cover%20of%20a%20young%20psionic%20warrior%20radiating%20golden%20energy%2C%20superpower%20action%20illustration%2C%20bold%20dynamic%20composition%2C%20glowing%20amber%20energy%20and%20dark%20background%2C%20dramatic%20lighting%2C%20high%20energy&width=600&height=800&seq=comic-lingneng&orientation=portrait',
  },
];

export const heroFeatures = [
  {
    key: 'hd',
    icon: 'ri-4k-line',
    title: '高清原图',
    desc: '最高 4K 无损画质，放大也清晰，保留每一处线条与网点的细节。',
  },
  {
    key: 'double',
    icon: 'ri-book-open-line',
    title: '双页浏览',
    desc: '模拟实体单行本翻页，左右双页无缝衔接，阅读更沉浸。',
  },
  {
    key: 'night',
    icon: 'ri-moon-clear-line',
    title: '夜间模式',
    desc: '自适应环境亮度的柔和深色界面，深夜追更也不刺眼。',
  },
  {
    key: 'zoom',
    icon: 'ri-zoom-in-line',
    title: '缩放设置',
    desc: '多点触控与滑杆精确缩放，聚焦对话分镜与细节画面。',
  },
  {
    key: 'scroll',
    icon: 'ri-arrow-down-double-line',
    title: '滚动阅读',
    desc: '纵轴连续滚动模式，手机横屏竖屏随心切换，一划到底。',
  },
];